import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of, take } from 'rxjs';
import { SubscriptionService } from '../services/subscription.service';

export const subscriptionGuard: CanActivateFn = () => {
  const router = inject(Router);
  const subscriptionService = inject(SubscriptionService);

  return subscriptionService.getStatus().pipe(
    take(1),
    map(status => status.accessAllowed
      ? true
      : router.createUrlTree(['/account/subscription'])),
    catchError(() => of(true)),
  );
};
